export default () => ({
  isContentLoaded: false,
  heroContent: {},
  statementContent: {},
  cardContent: {
    list: [],
  },
  bottomContent: {},
});
